import api from '/src/api/api';
import * as mutypes from "/src/store/mutation.types"

export default {
    state: () => {
        return {
            usersRating: [],
            pagination: {
                by: 10,
                currentPage: 1,
                totalPages: 1,
            },
            userRatingsPagination: {
                by: 10,
                currentPage: 1,
                totalPages: 1,
            },
            showUserRatings: null,
            bplSeasonUserRatingHistory: [],
            bplSeasonUserRatingHistoryPagination: {
                by: 30,
                currentPage: 1,
                totalPages: 1,
            },
        }
    },
    mutations: {
        [mutypes.SET_USERS_RATING]: (state, value) => state.usersRating = value,
        [mutypes.SET_USERS_RATING_PAGINATION_TOTAL]: (state, value) => state.pagination.totalPages = value,
        [mutypes.SET_USERS_RATING_PAGINATION_CURRENT_PAGE]: (state, value) => state.pagination.currentPage = value,
        [mutypes.SET_USER_RATINGS_SHOW]: (state, value) => state.showUserRatings = value,
        [mutypes.SET_USER_RATINGS_SHOW_PAGINATION_TOTAL]: (state, value) => state.userRatingsPagination.totalPages = value,
        [mutypes.SET_USER_RATINGS_SHOW_PAGINATION_CURRENT_PAGE]: (state, value) => state.userRatingsPagination.currentPage = value,
        [mutypes.SET_BPL_SEASON_USER_RATING_HISTORY]: (state, value) => state.bplSeasonUserRatingHistory = value,
        [mutypes.SET_BPL_SEASON_USER_RATING_HISTORY_PAGINATION_TOTAL]: (state, value) => state.bplSeasonUserRatingHistoryPagination.totalPages = value,
        [mutypes.SET_BPL_SEASON_USER_RATING_HISTORY_PAGINATION_CURRENT_PAGE]: (state, value) => state.bplSeasonUserRatingHistoryPagination.currentPage = value,
        [mutypes.SET_BPL_SEASON_USER_RATING_HISTORY_PAGINATION_BY]: (state, value) => state.bplSeasonUserRatingHistoryPagination.by = value,
    },

    getters: {
        getUsersRating: state => state.usersRating,
        getUsersRatingPaginationTotal: state => state.pagination.totalPages,
        getUsersRatingPaginationCurrentPage: state => state.pagination.currentPage,
        getUserRatingsShow: state => state.showUserRatings,
        getUserRatingsShowPaginationTotal: state => state.userRatingsPagination.totalPages,
        getUserRatingsShowPaginationCurrentPage: state => state.userRatingsPagination.currentPage,
        getBplSeasonUserRatingHistory: state => state.bplSeasonUserRatingHistory,
        getBplSeasonUserRatingHistoryPaginationTotal: state => state.bplSeasonUserRatingHistoryPagination.totalPages,
        getBplSeasonUserRatingHistoryPaginationCurrentPage: state => state.bplSeasonUserRatingHistoryPagination.currentPage,
        getBplSeasonUserRatingHistoryPaginationBy: state => state.bplSeasonUserRatingHistoryPagination.by,
    },

    actions: {
        grabUsersRating: async ({commit, getters}, params) => {
            let response = await api.usersRating.index({
                page: params.pageNumber,
                "search": params.search,
            });
            commit(mutypes.SET_USERS_RATING, response.data.users || []);
            commit(mutypes.SET_USERS_RATING_PAGINATION_TOTAL, response.data.pagination.total);
            commit(mutypes.SET_USERS_RATING_PAGINATION_CURRENT_PAGE, params.pageNumber);

            return response.status;
        },
        async showUserRatings({commit, getters}, params) {
            let response = await api.usersRating.show(params.id, {
                page: params.pageNumber,
            })
            commit(mutypes.SET_USER_RATINGS_SHOW, response.data)
            commit(mutypes.SET_USER_RATINGS_SHOW_PAGINATION_TOTAL, response.data.pagination.total);
            commit(mutypes.SET_USER_RATINGS_SHOW_PAGINATION_CURRENT_PAGE, params.pageNumber);
            return response.status;
        },
        async fetchBplSeasonUserRatingHistory({commit}, {seasonId, userId, pageNumber = 1}) {
            const response = await api.rating.getBplSeasonUserRatingHistory(seasonId, {
                user_id: userId,
                page: pageNumber,
            });
            const payload = response.data ?? response;
            commit(mutypes.SET_BPL_SEASON_USER_RATING_HISTORY, Array.isArray(payload.data) ? payload.data : []);
            if (payload.pagination) {
                commit(mutypes.SET_BPL_SEASON_USER_RATING_HISTORY_PAGINATION_TOTAL, payload.pagination.total);
                commit(mutypes.SET_BPL_SEASON_USER_RATING_HISTORY_PAGINATION_BY, payload.pagination.by);
            }
            commit(mutypes.SET_BPL_SEASON_USER_RATING_HISTORY_PAGINATION_CURRENT_PAGE, pageNumber);
            return response.status;
        },
    }
}